export const UxHelpers = {
  scrollLock: lock => {
    if (lock === 'lock' && !document.body.className.match('scroll-lock')) {
      document.body.classList.add('scroll-lock');
    }
    if (lock === 'unlock') {
      document.body.classList.remove('scroll-lock');
    }
  },

  // separate helper that does not mess up with usermenu
  overflowLock: lock => {
    if (lock === 'lock' && !document.body.className.match('overflow-lock')) {
      document.body.classList.add('overflow-lock');
    }
    if (lock === 'unlock') {
      document.body.classList.remove('overflow-lock');
    }
  },

  overlay: show => {
    if (show === 'show' && !document.body.className.match('app-overlay')) {
      document.body.classList.add('app-overlay');
    }
    if (show === 'hide') {
      document.body.classList.remove('app-overlay');
    }
  },
};

export default UxHelpers;
